import * as types from './action-types';
import * as endpoints from '../helpers/endpoints';
import apiRequest from '../helpers/apiRequest';

//Events Today Block
export const fetchDashboardResultsThunk = (filters, filtertype) => (
    dispatch,
    getState
) => {
    apiRequest(
        `${endpoints.EVENT_SEARCH_PATH}?${filters}`,
        getState().auth.jwtToken
    ).then(data => {
        dispatch(fetchDashboardResultsSuccess(data, filtertype));
    });
};

export const fetchDashboardResultsSuccess = (payload, filtertype) => ({
    type: types.FETCH_DASHBOARD_RESULTS_SUCCESS,
    payload,
    filtertype
});

//Cost Breakdown Block
export const fetchDashboardCostsThunk = filters => (dispatch, getState) => {
    apiRequest(
        `${endpoints.EVENT_SEARCH_PATH}?${filters}`,
        getState().auth.jwtToken
    ).then(data => {
        dispatch(fetchDashboardCostsSuccess(data));
    });
};

export const fetchDashboardCostsSuccess = payload => ({
    type: types.FETCH_DASHBOARD_COSTS_SUCCESS,
    payload
});

export const taskDueThunk = () => (dispatch, getState) => {
    dispatch(taskDueLoading());
    apiRequest(
        `${endpoints.EMS}user/${getState().data.userInfo.id}/all`,
        getState().auth.jwtToken
    )
        .then(payload => {
            dispatch(taskDueTotal(payload.data.tasks.length));
            dispatch(taskDueLoading());
        })
        .catch(err => {
            console.log(err);
            dispatch(taskDueLoading());
        });
};

export const taskDueLoading = () => ({
    type: types.TASKS_DUE_LOADING
});

export const taskDueTotal = total => ({
    type: types.TASKS_DUE_TOTAL,
    total
});

//Event Status Breakdown
export const eventStatusBreakdownThunk = (filters, filtertype) => (
    dispatch,
    getState
) => {
    dispatch(eventStatusBreakdownLoading());
    let userInfoCode = '';
    const billetLocation = getState().data.userInfo.Billet.location;
    const userInfo = getState().data.userInfo;

    if (billetLocation === 'RSS') {
        userInfoCode =
            '&filters[Event][recruitingSubStationCode][eq]=' +
            userInfo.RSS.code;
    } else if (billetLocation === 'OSS') {
        userInfoCode = '&filters[Event][ossCode][eq]=' + userInfo.OSS.ossNumber;
    } else if (billetLocation === 'RS') {
        userInfoCode =
            '&filters[Event][recruitingStationCode][eq]=' + userInfo.RS.code;
    } else if (billetLocation === 'District') {
        userInfoCode =
            '&filters[Event][districtCode][eq]=' + userInfo.District.code;
    } else if (billetLocation === 'Region') {
        userInfoCode =
            '&filters[Event][regionCode][eq]=' + userInfo.District.Region.code;
    }

    const eventCreations = apiRequest(
        `${
            endpoints.EVENT_SEARCH_PATH
        }?filters[Event][status][eq]=Incomplete${userInfoCode}`,
        getState().auth.jwtToken
    );
    const eventReview = apiRequest(
        `${
            endpoints.EVENT_SEARCH_PATH
        }?filters[Event][status][eq]=Unapproved${userInfoCode}`,
        getState().auth.jwtToken
    );
    const afterActionIncomplete = apiRequest(
        `${
            endpoints.EVENT_REPORT_PATH
        }?filters[Event][status][eq]=Incomplete${userInfoCode}`,
        getState().auth.jwtToken
    );
    const afterActionReview = apiRequest(
        `${
            endpoints.EVENT_REPORT_PATH
        }?filters[Event][status][eq]=Unapproved${userInfoCode}`,
        getState().auth.jwtToken
    );
    const afterActionPending = apiRequest(
        `${
            endpoints.EVENT_REPORT_PATH
        }?filters[Event][status][eq]=Pending${userInfoCode}`,
        getState().auth.jwtToken
    );
    const eventAAClosed = apiRequest(
        `${
            endpoints.EVENT_SEARCH_PATH
        }?filters[Event][status][eq]=Approved&filters[EventReport][status][eq]=Approved&filters[Event][endDate][gt]=moment().format('YYYY-MM-DD')${userInfoCode}`,
        getState().auth.jwtToken
    );

    Promise.all([
        eventCreations,
        eventReview,
        afterActionIncomplete,
        afterActionReview,
        afterActionPending,
        eventAAClosed
    ])
        .then(values => {
            dispatch(
                eventStatusBreakdownData(
                    'eventCreations',
                    values[0].data.length
                )
            );
            dispatch(
                eventStatusBreakdownData('eventReview', values[1].data.length)
            );
            dispatch(
                eventStatusBreakdownData(
                    'afterActionIncomplete',
                    values[2].data.length
                )
            );
            dispatch(
                eventStatusBreakdownData(
                    'afterActionReview',
                    values[3].data.length
                )
            );
            dispatch(
                eventStatusBreakdownData(
                    'afterActionPending',
                    values[4].data.length
                )
            );
            dispatch(
                eventStatusBreakdownData('eventAAClosed', values[5].data.length)
            );
            dispatch(eventStatusBreakdownLoading());
        })
        .catch(err => {
            console.log(err);
        });
};

export const eventStatusBreakdownLoading = () => ({
    type: types.EVENT_STATUS_BREAKDOWN_LOADING
});

export const eventStatusBreakdownData = (name, number) => {
    return {
        type: types.EVENT_STATUS_BREAKDOWN_DATA,
        eventStatusBreakDown: {
            [name]: number
        }
    };
};



// WEBPACK FOOTER //
// ./src/actions/dashboard.js